import { useEffect, useState } from "react";
import api from "./api";

const FALLBACK = { total: 4, taken: 0, remaining: 4, active: true, loaded: false };
let cache = null;
let inflight = null;

// Global Early Bird allocation status (4 direct bookings for the whole 2027 season), fetched once per page load.
export function useEarlyBird() {
  const [state, setState] = useState(cache || FALLBACK);
  useEffect(() => {
    if (cache) return;
    inflight = inflight || api.get("/settings/early-bird").then((r) => { cache = { ...r.data, loaded: true }; return cache; }).catch(() => ({ ...FALLBACK, loaded: true }));
    inflight.then(setState);
  }, []);
  return state;
}

export const resetEarlyBirdCache = () => { cache = null; inflight = null; };
